import { MapUtils } from '../../../utility/map-utils.js';
import { DataModel, DataModelBuilder, SerializationContext, SerializedData } from '../../dto/data-model.js';

export class DailyTicketSalesStats extends DataModel {
  static readonly TYPE_ID: string = '2feb9a35c363434b99351d6fe42344e1';

  constructor(
    public readonly offlineTickets: number,
    public readonly onlineTickets: number,
    public readonly totalTickets: number,
  ) {
    super();
  }

  get $typeId(): string {
    return DailyTicketSalesStats.TYPE_ID;
  }

  static empty(): DailyTicketSalesStats {
    return new DailyTicketSalesStats(0, 0, 0);
  }

  static legacy(totalTickets: number): DailyTicketSalesStats {
    return new DailyTicketSalesStats(0, 0, totalTickets);
  }

  static fromMap(
      context: SerializationContext,
      map: SerializedData,
  ): DailyTicketSalesStats {
    return new DailyTicketSalesStats(
        MapUtils.getNumber(map, 'offlineTickets'),
        MapUtils.getNumber(map, 'onlineTickets'),
        MapUtils.getNumber(map, 'totalTickets'),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      offlineTickets: this.offlineTickets,
      onlineTickets: this.onlineTickets,
      totalTickets: this.totalTickets,
    };
  }

  clone(): this {
    return new DailyTicketSalesStats(
        this.offlineTickets,
        this.onlineTickets,
        this.totalTickets,
    ) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return other.offlineTickets === this.offlineTickets &&
      other.onlineTickets === this.onlineTickets &&
      other.totalTickets === this.totalTickets;
  }
}

export class DailyTicketSalesStatsBuilder extends DataModelBuilder<DailyTicketSalesStats> {
  build(context: SerializationContext, map: SerializedData): DailyTicketSalesStats {
    return DailyTicketSalesStats.fromMap(context, map);
  }
}
